<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
				{{collapsed?'':sysName}}
			</el-col>
			<el-col :span="4" class="userinfo">
				<span class="el-dropdown-link userinfo-inner" v-if="sysUserName!=''&& sysMobile==''">  {{sysUserName}}</span>
				<span class="el-dropdown-link userinfo-inner" v-if="sysMobile!=''">  {{sysMobile}}</span>
				/ <a href="javascript:" @click="logout()" style="color:#fff;">退出登录</a>
			    / <a href="javascript:" @click="jumpTo()" style="color:#fff;">修改密码</a>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside class="asideborder">
				<!--导航菜单-->
				<el-radio-group v-model="isCollapse" class="switch fr pr20">
					 <img src="../../static/images/menu_left.png"
						class="sider_logo"
						id="siderLogo"
						@click="closeNav()" width="18" height="18">
				</el-radio-group>

				<el-scrollbar style="height:95%" class="cb">
		     	<el-menu class="leftMenu el-menu-vertical-demo"  router :default-active="$route.path" @open="handleOpen" @close="handleClose" :collapse="isCollapse">
						 <!-- <el-menu-item index="/platAdmin/pending">
							<i class="el-icon-menu"></i><span slot="title">主页</span>
						</el-menu-item> -->
						<template  v-for="(item, index) in menus"  >
							<el-submenu :index="index+'1'" v-if="item.url == 'P'" >
								<template slot="title">
									<i class="el-icon-menu"></i><span slot="title"> {{item.name}}</span>
								</template>
								<!--<el-menu-item v-for="(itemChild , index) in item.children" :index="'/platAdmin/'+itemChild.url" :key="index" >-->
										<!--<span>{{itemChild.name}}</span>-->
								<!--</el-menu-item>-->
								<el-menu-item v-for="(itemChild , index) in item.children" :index="'/platAdmin/'+itemChild.url" :key="index">
									<span v-if="itemChild.url!='onlineExam'">{{itemChild.name}}</span>
									<a  v-if="itemChild.url=='onlineExam'" target="_blank" :href="url"  style="color: #303133;text-decoration: none;" >
										{{itemChild.name}}
									</a>
								</el-menu-item>
							</el-submenu>
							<el-menu-item :index="'/platAdmin/'+item.url" v-if="item.url != 'P'">
							<i class="el-icon-menu"></i><span slot="title">{{item.name}}</span>
						</el-menu-item>
						</template>
				  </el-menu>
				</el-scrollbar>
			</aside>

			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<strong class="title mb10">{{$route.name}}</strong>
						<el-breadcrumb separator="/" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
								{{ item.name }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
		<!-- 修改密码 -->
		<el-dialog title="修改密码" :visible.sync="showModifyPassword" :close-on-click-modal="false" width="30%">
			<v_modifyPassword ref="appForm" v-bind:showModifyPassword="showModifyPassword"  @listenChildEvent="listenChildEvent"></v_modifyPassword>
		</el-dialog>
	</el-row>
</template>
<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
.main .asideborder{border-right: 1px solid #e6e6e6;}
.el-scrollbar__wrap {
  overflow-x: hidden;
}
.leftMenu{height:100%!important;border-right:none;}
.switch{padding:10px 0;cursor: pointer;}
</style>

<script>
    const url = "/"+"api/manager/onlineExam/authexam";
    import modifyPassword from './ModifyPassword.vue'
	export default {
		data() {
			return {
				sysName:process.env.TITLE_NAME,
				webUrl:process.env.WEB_URL,
				collapsed:false,
				sysUserName: '',
                sysMobile:"",
				sysUserAvatar: '',
				isCollapse: false,
                url:url,
				showModifyPassword: false,
				menus:[],
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				}
			}
		},
		methods: {
			closeNav () {
				this.isCollapse = !this.isCollapse
				var siderLogo = document.getElementById('siderLogo')
				if (this.isCollapse) {
					siderLogo.src = '../../static/images/menu_left.png'
					siderLogo.style.float = 'right'
				} else {
					siderLogo.src = '../../static/images/menu_left.png'
					siderLogo.style.float = 'right'
				}
				},
			handleOpen(key, keyPath) {
				console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				console.log(key, keyPath);
			},
			//退出登录
			logout: function () {
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
					 this.logoutFun();
				}).catch(() => {

				});
			},
			logoutFun(){
				this.$axiosPackag.get('/api/student/user/logout',null , res => {
							this.$sessionStore.clearSession();
					        window.parent.location.href=this.webUrl;
				});
			},
			getMyMenus(){
				var mymenus = this.$sessionStore.getMyMenus();
				if(mymenus == null) {mymenus = [];}
				console.info(mymenus);
				this.menus = this.$util.parentToChild(mymenus, 'id', 'parentId');
			},
			/**修改密码**/
			jumpTo () {
				this.showModifyPassword = true
			},
			 listenChildEvent(data){
                //监听子组件事件
                this.showModifyPassword =false;
            },
		},
		components: {
  		  v_modifyPassword: modifyPassword
        },
		mounted() {
			this.sysUserName = this.$sessionStore.getUserName();
            this.sysMobile = this.$sessionStore.getMobile();
			this.sysUserAvatar =this.$sessionStore.getHeadPicture();
			this.getMyMenus();
			$(document).ready(function(){
				$(".container").parents("body").css('background','none'); 
			});
		},
		created() {
		  // alert(process.env.ABC_R)
		}
	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';
	.menu_tools{height:60px;text-align:right;line-height: 60px;background-color:#fff;cursor: pointer;padding-right:21px;
	border-right: solid 1px #e6e6e6;border-bottom: 1px solid #dee1e3;}
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			background: $color-primary;
			color:#fff;
			.userinfo {
				text-align: right;
				padding-right: 35px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#fff;
					img {
						width: 40px;
						height: 40px;
						border-radius: 20px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				//width:230px;
				height:60px;
				font-size: 22px;
				padding-left:20px;
				padding-right:20px;
				// border-color: rgba(238,241,146,0.3);
				// border-right-width: 1px;
				// border-right-style: solid;
				img {
					width: 40px;
					float: left;
					margin: 10px 10px 10px 18px;
				}
				.txt {
					color:#fff;
				}
			}
			.logo-width{
				width:425px;
			}
			.logo-collapse-width{
				width:60px
			}
			.tools{
				padding: 0px 23px;
				width:14px;
				height: 60px;
				line-height: 60px;
			}
		}
		.main {
			display: flex;
			// background: #324057;
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;
			aside {
			//	flex:0 0 230px;
				//width: 230px;
				// position: absolute;
				// top: 0px;
				// bottom: 0px;
				.el-menu{
					height: 100%;
				//	width: 229px!important;
				}
				.collapsed{
					width:60px!important;
					.item{
						position: relative;
					}
					.submenu{
						position:absolute;
						top:0px;
						left:60px;
						z-index:99999;
						height:auto;
						display:none;
					}

				}
			}
			.menu-collapsed{
				flex:0 0 60px;
			}
			.menu-expanded{
				flex:0 0 230px;
			//	width: 230px;
			}
			.content-container {
				flex:1;
				overflow-y: scroll;
				padding: 20px;
				.breadcrumb-container {
					//margin-bottom: 15px;
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// Home.vue?055df66b